
var commonUtility = require('../../utils/domain/commonUtility');
var stringUtil = require('../../utils/string/stringUtil');
var constants = require('../../utils/domain/constants.js');
var stateManager = require('../../utils/state/stateManager');
var saleCommonUtility = require('../../utils/domain/sales/saleCommonUtility');
var saleCalculator = require('../../utils/domain/sales/saleCalculator');

module.exports.getFloors = function ()
{
    var floors = [];

    if (commonUtility.getProperty().layout == null)
        return floors;

    const floorsLayout = commonUtility.getProperty().layout;
    if (floorsLayout == null ||
        floorsLayout.floors == null ||
        floorsLayout.floors.length <= 0)
        return floors;

    floorsLayout.floors.forEach (floor =>
    {
        if (floor.stencils == null || floor.stencils.length <= 0)
            return;

        var seatingsStencils = floor.stencils.filter(stencil => stencil.type == constants.floorStencilType.Seating);
        if (seatingsStencils == null || seatingsStencils.length <= 0)
            return;
            
        floors.push(floor);
    });

    return floors;
}

module.exports.doesHaveFloorLayout = function ()
{
    return this.getFloors().length > 0;
}

module.exports.isAValidTableNumber = function (tableNumber)
{
    if (stringUtil.isStringNullOrEmpty(tableNumber))
        return false;

    if (!this.doesHaveFloorLayout())
        return false;

    var floors = this.getFloors();
    for (var index = 0; index < floors.length; index++)
    {
        var floor = floors[index];
        for (var iSubIndex = 0; iSubIndex < floor.stencils.length; iSubIndex++)
        {
            if (stringUtil.areStringSame(floor.stencils[iSubIndex].tableNumber, tableNumber))
                return true;
        }
    }

    return false;
}

module.exports.getTableOpenSale = function (tableNumber)
{
    let sales = stateManager.getStore().getState().todaySales;
    return sales.find (sale => !saleCommonUtility.isCancelled(sale) && 
                                sale.saleType != constants.SaleTypeHold && 
                                stringUtil.areStringSame(sale.tableNumber, tableNumber) &&
                                !saleCalculator.isSaleFullyPaid(sale));
}

module.exports.getMergedTableSale = function (tableNumber)
{
    let sales = stateManager.getStore().getState().todaySales;
    return sales.find (sale => !saleCommonUtility.isCancelled(sale) && 
                                sale.saleType != constants.SaleTypeHold && 
                                sale.linkedTables != null &&
                                sale.linkedTables.some(t => t == tableNumber) &&
                                !stringUtil.areStringSame(sale.tableNumber, tableNumber) &&
                                !saleCalculator.isSaleFullyPaid(sale));
}